// extracted by mini-css-extract-plugin
export var contact = "PrivacyRightsRequest-module--contact--56dc9";
export var container = "PrivacyRightsRequest-module--container--d24a8";
export var disclaimer = "PrivacyRightsRequest-module--disclaimer--fec3e";
export var downloadHeading = "PrivacyRightsRequest-module--downloadHeading--43e6d";
export var rights = "PrivacyRightsRequest-module--rights--0f34c";
export var title = "PrivacyRightsRequest-module--title--e58b1";